export const LOGIN_TARGET = "online-services-web";
